import web from "../src/images/1.jpg";
import app from "../src/images/2.jpeg";
import android from "../src/images/3.jpeg";
import digital from "../src/images/4.jpeg";
import marketing from "../src/images/5.jpeg";
import software from "../src/images/6.jpg";
const Sdata = [
    {
        imgsrc: web,
        title: "Web Development",
    },
    {
        imgsrc: app,
        title: "App Development",
    },
    {
        imgsrc: android,
        title: "Android Development",
    },
    {
        imgsrc: digital,
        title: "Digital Marketing",
    },
    {
        imgsrc: marketing,
        title: "Marketing",
    },
    {
        imgsrc: software,
        title: "Software Development",
    },
]

export default Sdata